import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../Assets/svg";

interface Props {
  open: boolean;
  onClose: () => void;
  note: string;
}

const ViewOverrideNoteModal: React.FC<Props> = ({ open, onClose, note }) => {
  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={svg?.closeIcon}
      width="36rem"
      className="commonModalClass"
      destroyOnClose={true}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">Approval Notes</div>
      }
    >
      <p className="text-center text-secondary mb-4">{note}</p>
    </Modal>
  );
};

export default ViewOverrideNoteModal;
